import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class FlyOverService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getWealthToken(userDetail: any): Observable<any> {
    const REST_URL = `${this.configService.apiUrl()}/fly-over`;

    return this.http.post(REST_URL, {
      email: userDetail.email,
      username: userDetail.username,
      roles: userDetail.roles,
      webId: userDetail.webId,
      role: userDetail.role
    });
  }
}
